import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const NoticesPage = lazyNamed(() => import('./NoticesPage'), 'NoticesPage');
const NoticeQueuePage = lazyNamed(() => import('./NoticeQueuePage'), 'NoticeQueuePage');
const CalendarPage = lazyNamed(() => import('./CalendarPage'), 'CalendarPage');
const NewsPage = lazyNamed(() => import('./NewsPage'), 'NewsPage');
const CronPage = lazyNamed(() => import('./CronPage'), 'CronPage');
const UploadsPage = lazyNamed(() => import('./UploadsPage'), 'UploadsPage');

/**
 * Staff routes for features/tools. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const toolsRoutes: RouteObject[] = [
  { path: 'tools/notices', element: <RequirePermission permission={['tools']}><NoticesPage /></RequirePermission> },
  { path: 'tools/notices/queue', element: <RequirePermission permission={['tools']}><NoticeQueuePage /></RequirePermission> },
  { path: 'tools/calendar', element: <RequirePermission permission={['tools', 'management']}><CalendarPage /></RequirePermission> },
  { path: 'tools/news', element: <RequirePermission permission={['news']}><NewsPage /></RequirePermission> },
  { path: 'tools/cron', element: <RequirePermission permission={['parameters']}><CronPage /></RequirePermission> },
  { path: 'tools/uploads', element: <RequirePermission permission={['tools']}><UploadsPage /></RequirePermission> },
];
